import { SB_FOLDER_BY_PROJECT_SLUG } from '@monoimin/constants';
import { ProjectSlug } from '@monoimin/sb-types';

export const getSiteRootFolder = (
  project: ProjectSlug,
  miniSite?: MiniSlug
) => {
  const rootFolder = SB_FOLDER_BY_PROJECT_SLUG[project];
  const subFolder = project === 'minisites' && miniSite ? `/${miniSite}` : '';

  return `${rootFolder}${subFolder}`;
};

export default getSiteRootFolder;
